import { useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import TableComponent from "../../components/TableComponent";
import SearchBox from "../../components/SearchComponent";
import { appApis, headerColumn } from "../../../constants";
import { useApiRequest } from "../../../hooks/useApiRequest";
import DateRangeSelector from "../../../Common/DateRangeElement";
import SearchableDropdown from "../../../Common/SearchDropdown";
import { parseNumber, reverseDateFormat } from "../../../utils";

const RequestSummary = () => {
    const [state, setState] = useState({
        installer: "",
        installerId: null,
        installerRequests: [],
        current: 1,
        total: 1,
        startDate: null,
        endDate: null
    });
    const { installerRequests, current, total, installer, installerId, startDate, endDate } = state;
     const { installers } = useSelector(state => state.installers, shallowEqual);
    const { request, loading } = useApiRequest();

    const getInstData = () => {
        if (startDate && endDate) {
            let query = `?startDate=${reverseDateFormat(startDate)}&endDate=${reverseDateFormat(endDate)}`;
            if (installerId) query += `&installerId=${installerId}`;
            request({
                url: `${appApis.installerReport}${query}`,
                showToast: false,
                onSuccess: (responseData) => {
                    setState(prev => ({ ...prev, installerRequests: responseData?.data ?? [] }))
                }
            })
        }
    }

    const filterByData = (range) => {
        if(range?.startDate && range?.endDate) setState(prev => ({...prev, ...range }))
    }

    useEffect(() => {
        getInstData();
    }, [installer, startDate, endDate])

    return <div className="installer-container">
        <TableComponent title={"Installer Request Summary"} col={4} headers={headerColumn.installersRequestSummary} data={installerRequests} tableLoading={loading} current={current} total={total} render={(tdData, index) => <tr key={index}>
            <td>{(index ?? 0) + 1}</td>
            <td>{tdData?.name ?? "-"}</td>
            <td>{tdData?.salary_type ?? "-"}</td>
            <td>{tdData?.salary ?? "-"}</td>
            <td>{tdData?.request_count ?? "-"}</td>
            <td>{(parseNumber(tdData?.salary ?? "") * parseNumber(tdData?.request_count ?? "")) ?? "-"}</td>
        </tr>} FilterComponent={
            <div className="installer-filters d-flex justify-content-end">
                <SearchableDropdown
                    placeholder={"Installers"}
                    value={installer}
                    error={false}
                    options={installers ?? []}
                    onSelect={(value) => setState(prev => ({ ...prev, installer: value?.name, installerId: value?.id }))}
                />
                <DateRangeSelector updateRange={filterByData} recentMonth={true} />
            </div>} />
    </div>
}

export default RequestSummary;